module.exports = __webpack_public_path__ + "content/04a4597825bf384d7d759565f1608745.png";